'use strict';

import {Glide, Controls, Swipe, Breakpoints, Images} from './components/carousel'

/**
 * initialisation for Einstein Carousel
 */
function initialiseSlotCarousel() {
    const $carousel = document.getElementsByClassName('js-einstein-slot-carousel');
    const $carouselItems = $($carousel).find('.glide__slide').not('.glide__slide--clone');
    const $controls = $($carousel).find('[data-glide-el="controls"]');
    const $glideBullets = $($carousel).find('[data-glide-el="controls[nav]"] .glide__bullet');
    const totalSlides = $carouselItems.length;
    $($carousel).closest('.recommendations').find('.script-container').html($($carousel).find('script').clone());
    $($carousel).find('script').remove();

    let glide;
    const defaults = {
        type: 'slider',
        perView: 4,
        rewind: false,
        bound: true,
        gap: 24,
        breakpoints: {
            1199: {
                rewind: true,
                perView: 3,
                gap: 16
            },
            719: {
                rewind: true,
                perView: 2,
                gap: 16
            }
        }
    };

    const handleUpdateEvent = () => {
        if (!glide) { return; }
        const { perView } = glide.settings;
        if (totalSlides <= perView) {
            $controls.removeClass('d-flex').addClass('d-none');
            $glideBullets.attr('disabled', 'disabled');
        } else {
            $controls.removeClass('d-none').addClass('d-flex');
            $glideBullets.removeAttr('disabled');
            $($carousel).closest('.product-recommendations-carousel').addClass('active-glide');
        }
    }

    glide = new Glide($carousel[0], defaults)
        .on('build.before', handleUpdateEvent)
        .mount({
            Controls,
            Breakpoints,
            Swipe,
            Images
        });
    
    handleUpdateEvent()
}

var loadingHtml =  `<div class="row slot-product-loading w-100">
<div class="col-md-4 col-lg-3 col-6 tile-loader">
    <div class="loader-image"></div>
    <div class="loader-title"></div>
    <div class="loader-title"></div>
    <div class="loader-price"></div>
</div>
<div class="col-md-4 col-lg-3 col-6 tile-loader">
    <div class="loader-image"></div>
    <div class="loader-title"></div>
    <div class="loader-title"></div>
    <div class="loader-price"></div>
</div>
<div class="d-none d-md-block col-md-4 col-lg-3 tile-loader">
    <div class="loader-image"></div>
    <div class="loader-title"></div>
    <div class="loader-title"></div>
    <div class="loader-price"></div>
</div>
<div class="d-none d-lg-block col-lg-3 tile-loader">
    <div class="loader-image"></div>
    <div class="loader-title"></div>
    <div class="loader-title"></div>
    <div class="loader-price"></div>
</div>
</div>`;

/**
 * Mutation Observor for Einstein Carousel to check if products are rendered on DOM or not
 */
function mutationObservor() {
    var $targetEle = $('div[id*="cq_recomm_slot-"]').first();
    var targetNode = $targetEle[0];
    var productContentFound = false;

    if (targetNode) {
        var observer = new MutationObserver(function(mutationsList) {
            mutationsList.forEach(function(mutation) {
                if (mutation.type === "childList") {
                    if (mutation.addedNodes.length > 0) {
                        productContentFound = true;
                        initialiseSlotCarousel();
                    }
                }
            });
        });
    
        var config = { childList: true, subtree: false };
    
        observer.observe(targetNode, config);
    }

    setTimeout(function() {
        if (!productContentFound) {
            $targetEle.find('.slot-product-loading').remove();
        }
    }, 5000);
}

$(document).ready(function () {
    var $targetEle = $('div[id*="cq_recomm_slot-"]').first();

    if ($targetEle.length) {
        $targetEle.append(loadingHtml);
    }
    mutationObservor();
});
